import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=66ea5e3a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=66ea5e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea5e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ea5e3a')) {
      api.createRecord('66ea5e3a', component.options)
    } else {
      api.reload('66ea5e3a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=66ea5e3a&scoped=true&", function () {
      api.rerender('66ea5e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SwBIqHg4LGK4/JS/comp/SearchFilterTokens.vue"
export default component.exports